import React from "react";
import { MdInfoOutline } from "react-icons/md";
import { css } from "glamor";
import { colors, spacing } from "../library/theme";

const wrapper = css({
  position: "relative",
  width: "100%",
});
const idBadge = css({
  position: "absolute",
  top: spacing.s,
  left: spacing.s,
  color: colors.greyShadow,
  fontSize: 14,
  letterSpacing: "0.02em",
});
const idLabel = {
  fontWeight: 700,
  textTransform: "uppercase",
  marginRight: 4,
};
const container = css({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  padding: spacing.m,
  textAlign: "center",
  width: "100%",
});
const icon = {
  color: colors.primaryDarker,
  marginBottom: spacing.s,
};
const title = {
  marginBottom: spacing.xxs,
};

export default function QuestionSearchUnsupported({ question }) {
  return (
    <div className={wrapper}>
      {question?.id && (
        <span className={idBadge}>
          <span style={idLabel}>Cód. da questão:</span>
          {question.id}
        </span>
      )}
      <div className={container}>
        <MdInfoOutline size={64} style={icon} />
        <h4 style={title}>Questão interativa</h4>
        <span>
          Esse tipo de questão só pode ser exibida dentro de uma aula ou simulado.
        </span>
      </div>
    </div>
  );
}
